<template>
    <div class="blackBackground labelComponentWrap">
        <div class="lavelTabNavToggle">
            <span class="backArrowIcon" id="close" @click="viewClose('someStatus')"></span>

            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <button type="button" class="nav-link" :class="{ active: activeTab === 'richlevel' }"
                        @click="activateTab('richlevel')">
                        Rich Level
                    </button>
                </li>

                <li class="nav-item">
                    <button type="button" class="nav-link" :class="{ active: activeTab === 'charmlevel' }"
                        @click="activateTab('charmlevel')">
                        Charm Level
                    </button>
                </li>
            </ul>
        </div>

        <div class="tab-content">
            <div class="tab-pane" :class="{ active: activeTab === 'richlevel' }">
                <div class="tab-contentIn" v-if="isLoadedRichLevel">
                    <Richlevel />
                </div>
            </div>

            <div class="tab-pane" :class="{ active: activeTab === 'charmlevel' }">
                <div class="tab-contentIn" v-if="isLoadedCharmLevel">
                    <Charmlevel />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { viewClose as androidViewClose } from '@/utils/android';
import { defineAsyncComponent } from "vue";

export default {
  name: "LevelComponent",

  components: {
    Richlevel: defineAsyncComponent(() => import("./RichLevel.vue")),
    Charmlevel: defineAsyncComponent(() => import("./CharmLevel.vue")),
  },

  data() {
    return {
      activeTab: "richlevel",
      isLoadedRichLevel: false,
      isLoadedCharmLevel: false,
    };
  },

  mounted() {
    this.checkURLParams();

    // optional prefetch
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        import("./CharmLevel.vue");
      });
    } else {
      setTimeout(() => {
        import("./CharmLevel.vue");
      }, 500);
    }
  },

  watch: {
    "$route.params.leveltype": "checkURLParams",
  },

  methods: {
    activateTab(tabId) {
      this.activeTab = tabId;

      if (tabId === "richlevel") this.isLoadedRichLevel = true;
      if (tabId === "charmlevel") this.isLoadedCharmLevel = true;
    },

    checkURLParams() {
      const leveltype = this.$route.params.leveltype;

      if (leveltype === "0") {
        this.activeTab = "richlevel";
        this.isLoadedRichLevel = true;
      } else if (leveltype === "1") {
        this.activeTab = "charmlevel";
        this.isLoadedCharmLevel = true;
      } else {
        // default
        this.activeTab = "richlevel";
        this.isLoadedRichLevel = true;
      }
    },

    viewClose(status) {
      if (window.Android && typeof Android.viewClose === "function") {
        androidViewClose(status);
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.viewClose
      ) {
        window.webkit.messageHandlers.viewClose.postMessage({ status });
      } else {
        window.parent.postMessage({ action: "closePopup", status }, "*");
      }
    },
  },
};
</script>
